module.exports = {"445103100":"古巷镇","445103101":"登塘镇","445103103":"凤塘镇","445103104":"浮洋镇","445103105":"龙湖镇","445103106":"金石镇","445103107":"沙溪镇","445103108":"彩塘镇","445103109":"东凤镇","445103110":"庵埠镇","445103114":"江东镇","445103115":"归湖镇","445103116":"文祠镇","445103117":"凤凰镇","445103120":"赤凤镇","445103121":"枫溪镇","445103400":"万峰林场","445103404":"大坑苗圃场","445103405":"东山湖农场","445103450":"庵埠经济开发试验区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445103.json
// module id = 2183
// module chunks = 0